/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupssettings1Inputs */

const en_groupssettings1 = /** @type {(inputs: Groupssettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const de_groupssettings1 = /** @type {(inputs: Groupssettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Groupssettings1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupssettings1 = /** @type {((inputs?: Groupssettings1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupssettings1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupssettings1(inputs)
	return de_groupssettings1(inputs)
});
export { groupssettings1 as "groupsSettings" }